const WhereHaveAllTheFlowersGone = [
	'Where have all the flowers gone, long time passing?',
	'Where have all the flowers gone, long time a-go?',
	'Where have all the flowers gone? Young girls picked them ev’ryone.',
	'When will they ever learn? When will they ever learn?',
	'',
	'Where have all the young girls gone, long time passing?',
	'Where have all the young girls gone, long time a-go?',
	'Where have all the young girls gone? Gone to husbands ev’ryone.',
	'When will they ever learn? When will they ever learn?',
	'',
	'Where have all the husbands gone, long time passing?',
	'Where have all the husbands gone, long time a-go?',
	'Where have all the husbands gone? Gone to soldiers ev’ryone.',
	'When will they ever learn? When will they ever learn?',
	'',
	'Where have all the soldiers gone, long time passing?',
	'Where have all the soldiers gone, long time a-go?',
	'Where have all the soldiers gone? Gone to graveyards ev’ryone.',
	'When will they ever learn? When will they ever learn?',
	'',
	'Where have all the graveyards gone, long time passing?',
	'Where have all the graveyards gone, long tine a-go?',
	'Where hav all the graveyards gone? Covered with flowers ev’ryone.',
	'When will they ever learn? When will they ever learn?',
	'',
	'Where have all the flowers gone, long time passing?',
	'Where have all the flowers gone, long time a-go?',
	'Where have all the flowers gone? Young girls picked them ev’ryone.',
	'When will they ever learn? When will they ever learn?',
];

export default WhereHaveAllTheFlowersGone;
